import
store
from '../store'

export default (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
  } else {
    localStorage.setItem('URL',to.path);
    next('global/signin')
  }
}
